import React, { useState, useEffect, useContext } from "react";
import { RecoveryContext } from "../../App";
import { useNavigate, Link } from "react-router-dom";
import axios from "../../Utils/axiosConfig";
import { LoadingPage } from "../LoadingPage";

import logo from "../Assets/Logo.svg";
import gamereview from "../Assets/Game-review.svg";
import ai from "../Assets/AI.svg";
import puzzles from "../Assets/Puzzles.svg";
import book from "../Assets/Book.svg";
import visualisation from "../Assets/Visualisation.svg";

export default function () {
  const { email, fromSignup, setUsername, fname, lname, username, password } =
    useContext(RecoveryContext);

  const [timerCount, setTimer] = React.useState(60);
  const [OTPinput, setOTPinput] = useState(["", "", "", ""]);
  const [disable, setDisable] = useState(true);
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const inputRefs = [
    React.useRef(),
    React.useRef(),
    React.useRef(),
    React.useRef(),
  ];

  function resetOTP() {
    setOTPinput(["", "", "", ""]);
    if (inputRefs[0].current) inputRefs[0].current.focus();
  }

  function resendOTP() {
    if (disable) return;

    const apiEndpoint = fromSignup
      ? "/send_recovery_email_signup"
      : "/send_recovery_email";

    setLoading(true);

    axios
      .post(apiEndpoint, {
        recipient_email: email,
      })
      .then(() => {
        setDisable(true);
        setAlertMessage("A new OTP has successfully been sent to your email.");
        setTimer(60);
        resetOTP();
      })
      .catch((error) => {
        setErrorMessage("Failed to send OTP. Please try again later.");
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }
  async function verifyOTP(passedOTP) {
    const enteredOTP = passedOTP || OTPinput.join("");

    if (enteredOTP.length !== 4) {
      setErrorMessage("Please enter the full 4-digit code.");
      return;
    }

    try {
      const verifyResponse = await axios.post("/verify-otp", {
        email: email,
        otp: enteredOTP,
      });

      if (verifyResponse.data.success) {
        if (fromSignup === false) {
          navigate("/ResetPassword");
        } else {
          const signupResponse = await axios.post("/signup", {
            fname,
            lname,
            username,
            email,
            password,
          });

          if (signupResponse.status === 201 || signupResponse.data.success) {
            const { token, username } = signupResponse.data;

            sessionStorage.setItem("username", username);
            sessionStorage.setItem("token", token);
            localStorage.removeItem("username");
            localStorage.removeItem("token");

            setUsername(username);

            setAlertMessage("Sign up successful.");
            setTimeout(() => {
              navigate("/ImportAccount");
            }, 2000);
          }
        }
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        setErrorMessage(
          "The code you have entered is not correct, try again or re-send the link"
        );
        resetOTP();
      } else {
        setErrorMessage("An unexpected error occurred. Please try again.");
      }
    }
  }

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    let interval = setInterval(() => {
      setTimer((lastTimerCount) => {
        lastTimerCount <= 1 && clearInterval(interval);
        if (lastTimerCount <= 1) setDisable(false);
        if (lastTimerCount <= 0) return lastTimerCount;
        return lastTimerCount - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [disable]);

  useEffect(() => {
    if (alertMessage) {
      setErrorMessage("");
      const alertTimer = setTimeout(() => {
        setAlertMessage("");
      }, 1500);
      return () => clearTimeout(alertTimer);
    } else if (errorMessage) {
      const errorTimer = setTimeout(() => {
        setErrorMessage("");
      }, 1500);
      return () => clearTimeout(errorTimer);
    }
  }, [alertMessage, errorMessage]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="container login-mobile-layout otp-mobile-layout">
      <header className="header">
        <img className="logo-image" src={logo} alt="logo" />
        <div className="logo-text">
          <span className="C-logo">C</span>
          <span className="hezzle-logo">
            he<span className="Z-1">Z</span>
            <span className="Z-2">Z</span>le
          </span>
        </div>
        <Link to="/login" className="login-button">
          Log in
        </Link>
      </header>
      <div className="gradient-line"></div>{" "}
      <div className="left-half">
        <img className="left-image" src={logo} alt="logo" />
        <div className="features">
          <ul>
            <li>
              <img src={gamereview} className="gamereview-svg" alt="" />
              Enhance your game analysis!
            </li>
            <br />
            <li>
              <img src={ai} className="ai-svg" alt="" />
              Get AI-assisted move breakdown.
            </li>
            <br />
            <li>
              <img src={puzzles} className="puzzles-svg" alt="" />
              Exclusive puzzles from your games!
            </li>
            <br />
            <li>
              <img src={book} className="book-svg" alt="" />
              Master your openings and middle game.
            </li>
            <br />
            <li>
              <img src={visualisation} className="visualisation-svg" alt="" />
              Level up your visualization skills!
            </li>
            <br />
          </ul>
        </div>
      </div>
      <div className="signup-form">
        <div className="line"></div>
        <h2 className="email-verification-button">Email Verification</h2>
        <div className="email-text">
          <p>
            We have sent a code to
            <br /> your email {email}
          </p>
        </div>

        <form onSubmit={(e) => e.preventDefault()}>
          <div className="otp-form">
            <div className="otp-boxes">
              <div className="otp-box">
                <input
                  ref={inputRefs[0]}
                  maxLength="1"
                  className="otp-box-input"
                  type="text"
                  value={OTPinput[0]}
                  onChange={(e) => {
                    const val = e.target.value;
                    setOTPinput([val, OTPinput[1], OTPinput[2], OTPinput[3]]);
                    if (val && inputRefs[1].current)
                      inputRefs[1].current.focus();
                  }}
                />
              </div>

              <div className="otp-box">
                <input
                  ref={inputRefs[1]}
                  maxLength="1"
                  className="otp-box-input"
                  type="text"
                  value={OTPinput[1]}
                  onChange={(e) => {
                    const val = e.target.value;
                    setOTPinput([OTPinput[0], val, OTPinput[2], OTPinput[3]]);
                    if (val && inputRefs[2].current)
                      inputRefs[2].current.focus();
                  }}
                />
              </div>

              <div className="otp-box">
                <input
                  ref={inputRefs[2]}
                  maxLength="1"
                  className="otp-box-input"
                  type="text"
                  value={OTPinput[2]}
                  onChange={(e) => {
                    const val = e.target.value;
                    setOTPinput([OTPinput[0], OTPinput[1], val, OTPinput[3]]);
                    if (val && inputRefs[3].current)
                      inputRefs[3].current.focus();
                  }}
                />
              </div>

              <div className="otp-box">
                <input
                  ref={inputRefs[3]}
                  maxLength="1"
                  className="otp-box-input"
                  type="text"
                  value={OTPinput[3]}
                  onChange={(e) => {
                    const val = e.target.value;

                    const fullOTP = [
                      OTPinput[0],
                      OTPinput[1],
                      OTPinput[2],
                      val,
                    ];

                    setOTPinput(fullOTP);

                    if (val) {
                      verifyOTP(fullOTP.join(""));
                    }
                  }}
                />
              </div>
            </div>

            <div className="flex flex-col space-y-5">
              <div>
                <a onClick={() => verifyOTP()} className="verify-otp-button">
                  Verify Account
                </a>
              </div>

              <div className="didnt-receive-code">
                <p>Didn't receive code?</p>{" "}
                <div className="resend-otp-link">
                  <a
                    style={{
                      color: disable ? "rgb(209, 207, 207)" : "#C2C4FF",
                      cursor: disable ? "auto" : "pointer",
                      textDecorationLine: disable ? "none" : "underline",
                    }}
                    onClick={() => resendOTP()}
                  >
                    {disable ? `Resend OTP in ${timerCount}s` : "Resend OTP"}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div>
          {errorMessage && <p className="error-message">{errorMessage}</p>}
          {alertMessage && <p className="alert-message">{alertMessage}</p>}
        </div>
      </div>
    </div>
  );
}
